import request from '@/services/request'

export function getMasterUomList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom/common-list',
    method: 'get'
  })
}

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom-detail/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom-detail/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom-detail/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom-detail/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom-detail/update',
    method: 'put',
    data: data
  })
}

export function getMasterUomDetailList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-uom-detail/common-list',
    method: 'get'
  })
}






// WEBPACK FOOTER //
// ./src/api/master_uom_detail.js